const state = {
    seleccionados: null,
    masutilizados: null
};
 
export default state;
